/*
  Resolargrip: cabecera con movimiento.
  - Fija arriba al hacer scroll (la barra naranja de avisos se va, la cabecera se queda).
  - Opcional: se oculta al bajar y vuelve al subir.
  - Opcional: línea naranja con el avance de la página.
  Solo cambia clases y transformaciones (sin mover el contenido de la página).
  Se activa con las clases que pone sections/header.liquid en <html> según sus ajustes.
*/
(function () {
  var raiz = document.documentElement;
  var seccion = document.getElementById('shopify-section-header');
  if (!seccion || !raiz.classList.contains('rg-cabecera-fija')) return;

  var anuncio = seccion.querySelector('.announcement-bar');
  var inteligente = raiz.classList.contains('rg-cabecera-inteligente');
  var progreso = raiz.classList.contains('rg-cabecera-progreso');
  var ultimaY = window.pageYOffset;
  var pendiente = false;

  // La barra de avisos se esconde por arriba: la cabecera se pega justo debajo de ella
  function medirAnuncio() {
    raiz.style.setProperty('--rg-anuncio', (anuncio ? anuncio.offsetHeight : 0) + 'px');
  }

  // No esconder la cabecera si el menú, la búsqueda o un desplegable están abiertos, o si el ratón está encima
  function hayAlgoAbierto() {
    return (
      document.body.classList.contains('js-drawer-open') ||
      seccion.querySelector('.js-menu--is-open, .site-nav--active-dropdown') !== null ||
      seccion.contains(document.activeElement) ||
      seccion.matches(':hover')
    );
  }

  function actualizar() {
    pendiente = false;
    var y = window.pageYOffset;
    var alto = seccion.offsetHeight;

    raiz.classList.toggle('rg-cabecera--scroll', y > 10);

    if (inteligente) {
      if (y > alto + 120 && y > ultimaY + 6 && !hayAlgoAbierto()) {
        raiz.classList.add('rg-cabecera--oculta');
      } else if (y < ultimaY - 6 || y <= alto) {
        raiz.classList.remove('rg-cabecera--oculta');
      }
    }

    if (progreso) {
      var maximo = raiz.scrollHeight - window.innerHeight;
      seccion.style.setProperty('--rg-progreso', maximo > 0 ? Math.min(1, y / maximo).toFixed(4) : 0);
    }

    ultimaY = y;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!pendiente) {
        pendiente = true;
        window.requestAnimationFrame(actualizar);
      }
    },
    { passive: true }
  );

  window.addEventListener('resize', function () {
    medirAnuncio();
    actualizar();
  });

  // Si alguien navega con el teclado hasta la cabecera, que se vea
  seccion.addEventListener('focusin', function () {
    raiz.classList.remove('rg-cabecera--oculta');
  });

  medirAnuncio();
  actualizar();
})();

/*
  Aparición al llegar con el scroll: elementos con [data-rg-animar] reciben .rg-visible.
  Sin JavaScript o con «reducir movimiento» se ven directamente, sin animación.
*/
(function () {
  var elementos = document.querySelectorAll('[data-rg-animar]');
  if (!elementos.length) return;
  var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sinMovimiento || !('IntersectionObserver' in window)) return;

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('rg-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.35 }
  );

  Array.prototype.forEach.call(elementos, function (elemento) {
    elemento.classList.add('rg-animable');
    observador.observe(elemento);
  });
})();

/*
  Muestras de color en la ficha de producto (sections/product-template.liquid).
  Al elegir una muestra se cambia el desplegable oculto de Debut y se avisa con un «change»,
  así Debut actualiza precio, foto y variante como siempre. Y al revés: si el desplegable
  cambia por otro motivo, la muestra marcada y el nombre del color se sincronizan.
*/
(function () {
  function selectDe(elemento) {
    var item = elemento.closest('.product-form__item');
    return item ? item.querySelector('select.single-option-selector') : null;
  }

  function sincronizar(select) {
    var item = select.closest('.product-form__item--muestras');
    if (!item) return;
    var nombre = item.querySelector('[data-rg-elegido]');
    if (nombre) nombre.textContent = select.value;
    Array.prototype.forEach.call(item.querySelectorAll('[data-rg-muestra]'), function (radio) {
      radio.checked = radio.value === select.value;
    });
  }

  document.addEventListener('change', function (evento) {
    var elemento = evento.target;
    if (!elemento || !elemento.closest) return;

    if (elemento.hasAttribute('data-rg-muestra')) {
      var select = selectDe(elemento);
      if (select && select.value !== elemento.value) {
        select.value = elemento.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (elemento.classList.contains('single-option-selector')) {
      sincronizar(elemento);
    }
  });
})();

/*
  Colores bajo los productos de la portada (snippets/product-card-grid.liquid):
  al pasar por encima (o tocar en el móvil) un color, la foto de la tarjeta cambia a ese color.
*/
(function () {
  function mostrarColor(boton) {
    var tarjeta = boton.closest('.product-card');
    var imagen = tarjeta && tarjeta.querySelector('.grid-view-item__image');
    if (!imagen) return;

    Array.prototype.forEach.call(tarjeta.querySelectorAll('.product-card__color'), function (otro) {
      otro.classList.toggle('is-activo', otro === boton);
    });

    var url = boton.getAttribute('data-rg-imagen');
    if (!url || imagen.getAttribute('src') === url) return;
    // lazysizes rellena srcset: se quita para que el navegador use la foto del color
    imagen.removeAttribute('srcset');
    imagen.removeAttribute('data-srcset');
    imagen.setAttribute('src', url);
  }

  function colorDe(evento) {
    return evento.target && evento.target.closest ? evento.target.closest('.product-card__color') : null;
  }

  document.addEventListener('mouseover', function (evento) {
    var boton = colorDe(evento);
    if (boton) mostrarColor(boton);
  });

  document.addEventListener('focusin', function (evento) {
    var boton = colorDe(evento);
    if (boton) mostrarColor(boton);
  });

  document.addEventListener('click', function (evento) {
    var boton = colorDe(evento);
    if (!boton) return;
    evento.preventDefault();
    mostrarColor(boton);
  });
})();

/*
  Vídeos de Instagram (sections/videos-instagram.liquid): solo se ven las portadas.
  Al pulsar play se cambia la portada por el vídeo y empieza a reproducirse (el MP4 no se descarga antes).
  Solo suena un vídeo a la vez.
*/
(function () {
  function pausarOtros(actual) {
    Array.prototype.forEach.call(document.querySelectorAll('.videos-ig video'), function (video) {
      if (video !== actual && !video.paused) video.pause();
    });
  }

  document.addEventListener('click', function (evento) {
    var boton = evento.target && evento.target.closest ? evento.target.closest('[data-rg-video]') : null;
    if (!boton) return;
    evento.preventDefault();

    var video = document.createElement('video');
    video.className = 'videos-ig__video';
    // iPhone y Safari reproducen la versión adaptativa (empieza antes con poca cobertura); el resto, el MP4
    var hls = boton.getAttribute('data-rg-hls');
    var usarHls = hls && video.canPlayType('application/vnd.apple.mpegurl');
    video.src = usarHls ? hls : boton.getAttribute('data-rg-video');
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    var portada = boton.querySelector('img');
    if (portada) video.poster = portada.currentSrc || portada.src;
    video.setAttribute('aria-label', boton.getAttribute('aria-label') || 'Vídeo');

    boton.parentNode.replaceChild(video, boton);
    pausarOtros(video);
    var reproduccion = video.play();
    if (reproduccion && reproduccion.catch) reproduccion.catch(function () {});
    video.focus();
  });

  // Si se reproduce uno con sus propios controles, se paran los demás
  document.addEventListener('play', function (evento) {
    if (evento.target && evento.target.tagName === 'VIDEO' && evento.target.closest('.videos-ig')) {
      pausarOtros(evento.target);
    }
  }, true);
})();

/*
  Resolargrip: aviso de arriba en movimiento (sections/header.liquid, «Movimiento del aviso»).
  - Cinta: repite los mensajes hasta llenar la barra y los hace pasar sin parar (se para con el ratón encima).
  - Alternar: enseña un mensaje cada vez; el nuevo sube desde abajo.
  Los mensajes repetidos se marcan aria-hidden para que los lectores de pantalla no los lean dos veces.
*/
(function () {
  var ventana = document.querySelector('[data-rg-aviso]');
  if (!ventana) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var barra = ventana.closest('.rg-aviso');
  var pista = ventana.querySelector('.rg-aviso__pista');
  var grupo = ventana.querySelector('.rg-aviso__grupo');
  var originales = Array.prototype.slice.call(grupo.children);
  if (!barra || !originales.length) return;

  if (ventana.getAttribute('data-rg-aviso') === 'cinta') {
    var velocidad = parseFloat(ventana.getAttribute('data-rg-velocidad')) || 40;
    var ancho = 0;

    var montar = function () {
      ancho = ventana.offsetWidth;
      if (!ancho) return;
      while (pista.children.length > 1) pista.removeChild(pista.lastChild);
      while (grupo.children.length > originales.length) grupo.removeChild(grupo.lastChild);

      // Un grupo tiene que ocupar al menos la barra entera; luego se pone otro igual detrás y
      // la cinta avanza justo un grupo antes de volver a empezar, así no se nota el salto
      for (var vueltas = 0; grupo.offsetWidth < ancho && vueltas < 30; vueltas++) {
        originales.forEach(function (item) {
          var copia = item.cloneNode(true);
          copia.setAttribute('aria-hidden', 'true');
          grupo.appendChild(copia);
        });
      }
      var segundo = grupo.cloneNode(true);
      segundo.setAttribute('aria-hidden', 'true');
      pista.appendChild(segundo);

      pista.style.setProperty('--rg-cinta-duracion', (grupo.offsetWidth / velocidad).toFixed(2) + 's');
      barra.classList.add('rg-aviso--lista');
    };

    montar();

    // Cuando llega la letra definitiva los textos cambian de ancho: se vuelve a medir solo si hace falta
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (grupo.offsetWidth < ventana.offsetWidth) montar();
      });
    }

    // Si cambia el ancho de la barra (girar el móvil, ventana más grande) se vuelve a montar
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (ventana.offsetWidth !== ancho) montar();
      }).observe(ventana);
    } else {
      var espera;
      window.addEventListener('resize', function () {
        clearTimeout(espera);
        espera = setTimeout(function () {
          if (ventana.offsetWidth !== ancho) montar();
        }, 200);
      });
    }
    return;
  }

  // Un mensaje cada vez
  if (originales.length < 2) return;
  var pausa = (parseFloat(ventana.getAttribute('data-rg-pausa')) || 4) * 1000;
  var actual = 0;
  var quieto = false;

  barra.classList.add('rg-aviso--lista');
  originales.forEach(function (item, i) {
    if (i > 0) item.setAttribute('aria-hidden', 'true');
  });
  originales[0].classList.add('es-activo');

  setInterval(function () {
    if (quieto || document.hidden) return;
    var saliente = originales[actual];
    actual = (actual + 1) % originales.length;
    var entrante = originales[actual];

    saliente.classList.remove('es-activo');
    saliente.classList.add('es-saliente');
    saliente.setAttribute('aria-hidden', 'true');
    entrante.classList.remove('es-saliente');
    entrante.classList.add('es-activo');
    entrante.removeAttribute('aria-hidden');
    setTimeout(function () {
      saliente.classList.remove('es-saliente');
    }, 650);
  }, pausa);

  // Con el ratón encima o con el teclado dentro, el mensaje no cambia (al tocar con el dedo, sí)
  barra.addEventListener('pointerenter', function (evento) {
    if (evento.pointerType === 'mouse') quieto = true;
  });
  barra.addEventListener('pointerleave', function () { quieto = false; });
  barra.addEventListener('focusin', function () {
    quieto = !!barra.querySelector(':focus-visible');
  });
  barra.addEventListener('focusout', function () { quieto = false; });
})();
